Ext.define('SA.CrosstabDragController', {
    msPerFrame: 1000 / 60, 
    scrollDeltaPerFrame: 6, 

    constructor({table}) {
        this.table = table;

        this.listeners = {};

        this.table.on('cell:dragstart', this.onDragStart, this);
        this.table.on('cell:drag', this.onDrag, this);
        this.table.on('cell:dragend', this.onDragEnd, this);
    },

    fireEvent(event, detail = {}) {
        return this.listeners[event](detail);
    },

    getSectionCells(section) {
        return section.top ? this.table.getTopCells() : this.table.getLeftCells();
    },

    getSectionDropZones(section) {
        var boxes = this.getSectionCells(section).map(cell => cell.getBox()),
            getStart = section.top ? (box => box.left) : (box => box.top),
            getEnd = section.top ? (box => box.right) : (box => box.bottom),
            starts = [Number.NEGATIVE_INFINITY, ...boxes.map(getStart)],
            ends = [...boxes.map(getEnd), Number.POSITIVE_INFINITY];

        return starts.map((start, index) => ({start, end: ends[index]}));
    },

    getSectionTargetIndex(section) {
        var dragBox = this.draggable.getBox(),
            dragCenter = section.top ? ((dragBox.left + dragBox.right) / 2) : ((dragBox.top + dragBox.bottom) / 2),
            isTargetedZone = box => (box.start <= dragCenter) && (dragCenter <= box.end),
            firstCellInFrame = this.getSectionCells(section)[0],
            index = this.getSectionDropZones(section).findIndex(isTargetedZone) - 1; 

        if (firstCellInFrame.isTotal()) {
            index = Math.max(index, 0);
        }

        return index;
    },

    getTargetPosition(lastPosition) {
        var section = this.getTargetSection(lastPosition),
            index = section.none ? null : this.getSectionTargetIndex(section);

        return Object.assign(section, {index});
    },

    getTargetScrollDelta(timeDelta) {
        var dragBox = this.draggable.getBox(),
            topBox = this.table.getTopBox(),
            leftBox = this.table.getLeftBox(),
            scrollability = this.table.getScrollability(),
            scrollDelta = Math.ceil(this.scrollDeltaPerFrame * (timeDelta / this.msPerFrame)),
            x = 0,
            y = 0;

        if (this.targetPosition.top) {
            if (scrollability.left && dragBox.left < topBox.left) {
                x = -scrollDelta;
            }
            else if (scrollability.right && dragBox.right > topBox.right) {
                x = scrollDelta;
            }
        }
        else if (this.targetPosition.left) {
            if (scrollability.up && dragBox.top < leftBox.top) {
                y = -scrollDelta;
            }
            else if (scrollability.down && dragBox.bottom > leftBox.bottom) {
                y = scrollDelta;
            }
        }

        return [x, y];
    },

    getTargetSection() {
        var dragBox = this.draggable.getBox(),
            canTargetTop = this.table.getTopBox().intersect(dragBox),
            canTargetLeft = this.table.getLeftBox().intersect(dragBox),
            targetTop = (canTargetTop && !canTargetLeft) || (canTargetTop && this.targetPosition.top),
            targetLeft = (canTargetLeft && !canTargetTop) || (canTargetLeft && this.targetPosition.left);

        return {top: targetTop, left: targetLeft, none: !targetTop && !targetLeft};
    },

    on(event, callback, scope) {
        this.listeners[event] = callback.bind(scope);
    },

    onDrag(ev) {
        this.draggable.setMouseXy(ev.detail.xy);
    },

    refreshDrag() {
        if (!this.draggable) {
            return;
        }

        var currentTime = performance.now(),
            timeDelta = currentTime - this.lastTime;

        this.lastTime = currentTime;
        this.targetPosition = this.getTargetPosition();

        this.fireEvent('refresh', {position: this.targetPosition, scrollDelta: this.getTargetScrollDelta(timeDelta)});

        requestAnimationFrame(() => this.refreshDrag());
    },

    onDragEnd() {
        Ext.destroyMembers(this, 'draggable');

        this.fireEvent('end');
    },

    onDragStart(ev) {
        var {xy, attribute, draggableParams} = ev.detail,
            dragAllowed = this.fireEvent('start', {attribute});

        if (dragAllowed === false) {
            ev.preventDefault();
            return;
        }

        this.lastTime = performance.now() - this.msPerFrame; 
        this.draggable = new SA.DraggableCell(Object.assign({xy}, draggableParams));

        this.refreshDrag();
    }
});